'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _numberField = require('./numberField.html');

var _numberField2 = _interopRequireDefault(_numberField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberField = {

    bindings: {
        modal: '=',
        maxLength: '@',
        readOnly: '=?'
    },
    template: _numberField2.default,
    controller: function controller() {
        var _this = this;

        this.$onInit = function () {
            _this.oldModal = angular.copy(_this.modal);
        };
        this.checkLength = function () {
            if (_this.modal && _this.modal.toString().length > _this.maxLength) {
                _this.modal = angular.copy(_this.oldModal);
            } else {
                _this.oldModal = angular.copy(_this.modal);
            }
        };
    }
};

exports.default = numberField;


/** WEBPACK FOOTER **
 ** ./src/app/directives/numberField/numberField.js
 **/